//export const SlideDirection = ["SlideDown", "SlideUp", "SlideStay"];
export const SlideDirection = ["slide-down", "slide-up", "SlideStay"];
export const TRANSITIONSPEED = 800